import { connect } from 'react-redux';

import { navigateFromMegaMenu } from 'redux/modules/page/actions/navigate-from-mega-menu';
import { setMegaMenuState } from 'redux/modules/page/actions/set-mega-menu-state';
import { getMegaMenuActiveLevel } from 'redux/modules/page/selectors/mega-menu';

import CMSMenuLink from './CMSMenuLink';

export default connect(
  state => ({
    level: getMegaMenuActiveLevel(state),
  }),
  {
    navigateFromMegaMenu,
    setMegaMenuState,
  },
)(CMSMenuLink);
